import { useMemo } from "react";
import {
  fileDocGroupAndTypes,
  fileDocGroupAndTypesAll,
  fileDocGroupAndTypesBorrower,
} from "../../constants/fileDocGroupAndTypes";

/**
 * Borrower
 * rm
 *
 */
export const useFileDocGroupAndTypesHook = ({
  showAllDocTypes = false,
  showBorrowerDocTypes = false,
}) => {
  // const fileDocGroupAndTypes = useSelector(
  //   (state) => state.fetchedSelections?.fileDocGroupAndTypes || {}
  // );
  const targetFileDocGroupsAndTypes = useMemo(() => {
    if (showBorrowerDocTypes) {
      return fileDocGroupAndTypesBorrower;
    }
    if (showAllDocTypes) {
      return fileDocGroupAndTypesAll;
    }
    // Filter logic for specific types can be added here
    return fileDocGroupAndTypes;
  }, [showAllDocTypes, showBorrowerDocTypes]);

  const fileDocGroups = Object.keys(targetFileDocGroupsAndTypes);
  const getFileDocGroups = (docGroupTypesObject) => {
    if (docGroupTypesObject) {
      return Object.keys(docGroupTypesObject);
    }
    return fileDocGroups;
  };

  const getDocTypesByGroup = (group, docGroupTypesObject) => {
    if (docGroupTypesObject) {
      return docGroupTypesObject[group];
    }
    return targetFileDocGroupsAndTypes[group];
  };

  const searchDocumentsAdvanced = (searchTerm) => {
    if (!searchTerm || typeof searchTerm !== "string") {
      return targetFileDocGroupsAndTypes;
    }

    const normalizedSearchTerm = searchTerm.toLowerCase().trim();

    if (normalizedSearchTerm === "") {
      return targetFileDocGroupsAndTypes;
    }

    // Split search term into words for better matching
    const searchWords = normalizedSearchTerm.split(/\s+/);

    const results = {};

    Object.entries(targetFileDocGroupsAndTypes).forEach(
      ([docGroup, docTypes]) => {
        const normalizedDocGroup = docGroup.toLowerCase();

        // Check if docGroup matches any search word
        const docGroupMatches = searchWords.some((word) =>
          normalizedDocGroup.includes(word),
        );

        // Find matching doc types
        const matchingDocTypes = docTypes.filter((docType) => {
          const normalizedDocType = docType.toLowerCase();
          return searchWords.some((word) => normalizedDocType.includes(word));
        });

        if (docGroupMatches || matchingDocTypes.length > 0) {
          results[docGroup] = docGroupMatches ? docTypes : matchingDocTypes;
        }
      },
    );

    return results;
  };

  const getDocumentTypeOptions = (passedFileDocGroupAndTypes) => {
    const fileDocGroupAndTypesObject =
      passedFileDocGroupAndTypes || targetFileDocGroupsAndTypes;
    const options = [];

    Object.entries(fileDocGroupAndTypesObject).forEach(([group, docTypes]) => {
      docTypes.forEach((docType) => {
        options.push({
          label: `${group} > ${docType}`,
          value: `${group} > ${docType}`,
          docGroup: group,
          docType: docType,
        });
      });
    });

    return options;
  };

  const formatDocTypeLabel = (docType) => {
    const DOC_LABEL_OVERRIDES = {
      COGS: "Certificate of Good Standing",
      EIN: "EIN Letter from IRS",
      "Borrower Experience - HUDs, Loan Docs": "HUDs, Loan Docs",
      "Borrower Experience - Personal Financial Statement":
        "Personal Financial Statement",
      "Borrower Experience - Property Reports": "Property Reports",
      "Borrower Experience - REO Schedule": "REO Schedule",
      "Borrower Experience - Sourcing Entity Docs": "Sourcing Entity Docs",
      "Borrower Experience - Track Record": "Track Record",
    };
    return DOC_LABEL_OVERRIDES[docType] || docType;
  };

  return {
    fileDocGroupAndTypes: targetFileDocGroupsAndTypes,
    fileDocGroups,
    getDocTypesByGroup,
    getDocumentTypeOptions,
    searchDocumentsAdvanced,
    getFileDocGroups,
    formatDocTypeLabel,
  };
};

/**
  const fileDocGroupAndTypes = useSelector(
    (state) => state.fetchedSelections?.fileDocGroupAndTypes
  );

  const {
    fileDocGroupAndTypes,
    fileDocGroups,
    getDocTypesByGroup,
    getDocumentTypeOptions,
    searchDocumentsAdvanced,
    getFileDocGroups,
  } = useFileDocGroupAndTypesHook({});

 */
